import { render, staticRenderFns } from "./LoanWaivers.vue?vue&type=template&id=685953b1&scoped=true"
import script from "./LoanWaivers.vue?vue&type=script&lang=js"
export * from "./LoanWaivers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685953b1",
  null
  
)

export default component.exports